<p-button
    [label]="'v' + knightflyVersion"
    size="small"
    [text]="true"
    severity="secondary"
    styleClass="!text-secondary !font-medium !px-2"
    (onClick)="versionsPopover.toggle($event)"
/>

<p-popover #versionsPopover [style]="{ width: '300px' }">
    <div class="flex flex-col gap-2 p-1">
        <label class="text-xs font-medium text-gray-500">Component Versions</label>
        <div class="grid grid-cols-[1fr_auto] gap-x-3 gap-y-1 text-sm max-h-80 overflow-auto">
            @for (v of versions; track v.slug) {
                <span>{{ v.label }}</span>
                <span class="font-mono text-gray-500">v{{ v.version }}</span>
            }
        </div>
        <a routerLink="/edm/docs/changelog" class="text-xs text-primary mt-1">View full changelog &rarr;</a>
    </div>
</p-popover>
